export const IconJooble20: {
  name: 'icon_jooble_20-267774447ce6'
} = {
  name: 'icon_jooble_20-267774447ce6'
}
